module.exports = __webpack_public_path__ + "img/open_mouth.1db71fff.png";